// extracted by mini-css-extract-plugin
export default {"download":"styles_download__urMZv","loadingSpinner":"styles_loadingSpinner__pla9v"};